<template>
  <div ref="MemoramInstructions" class="transparent memoram-instructions">
    <p
      v-for="(paragraph, i) in $t('portfolio.memoram.instructions.paragraph')"
      v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
      :key="`porfolioMemoramInstructionsParagraph-${i}`"
    />

    <h2>{{ $t("portfolio.memoram.instructions.howToPlay.title") }}</h2>
    <hr class="secondary" />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.data.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.data.paragraph") }}</p>
    <img
      :alt="$t('portfolio.memoram.instructions.howToPlay.data.altLabel')"
      src="/img/3DTextures/memoram/instructions/box.png"
      class="memoram-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.questions.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.questions.paragraph") }}</p>
    <img
      :alt="$t('portfolio.memoram.instructions.howToPlay.questions.altLabel')"
      src="/img/3DTextures/memoram/instructions/question-board.png"
      class="memoram-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.questionCard.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.questionCard.paragraph") }}</p>
    <img
      :alt="$t('portfolio.memoram.instructions.howToPlay.questionCard.altLabel')"
      src="/img/3DTextures/memoram/instructions/question-card.png"
      class="memoram-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.movingToAnswers.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.movingToAnswers.paragraph") }}</p>

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.answers.title") }}</h3>
    <p
      v-html="
        $t('portfolio.memoram.instructions.howToPlay.answers.paragraph', {
          purple: 'text-white-purple'
        })
      "
    />
    <img
      :alt="$t('portfolio.memoram.instructions.howToPlay.answers.altLabel')"
      src="/img/3DTextures/memoram/instructions/answer-board.png"
      class="memoram-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.answerCard.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.answerCard.paragraph") }}</p>
    <img
      :alt="$t('portfolio.memoram.instructions.howToPlay.answerCard.altLabel')"
      src="/img/3DTextures/memoram/instructions/answer-card.png"
      class="memoram-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.memoram.instructions.howToPlay.movingToQuestions.title") }}</h3>
    <p>{{ $t("portfolio.memoram.instructions.howToPlay.movingToQuestions.paragraph") }}</p>
  </div>
</template>

<script>
export default {
  name: "MemoramInstructions"
};
</script>

<style lang="scss" scoped>
.memoram-instructions {
  &-image {
    @include boxShadow(0.35, true, false);
    border: 0.0625rem solid $main-blue;
    background-color: $white-raw;
    border-radius: 0.45rem;
    display: flex;
    margin: 2rem auto;
    max-width: 100%;
    max-height: 100%;

    &.black {
      border: 0.125rem solid $main-green;
      background-color: $dark-raw;
    }

    &.hero {
      @include breakpoint($xlarge) {
        height: 45vh;
        width: auto;
      }

      @include breakpoint($xxxlarge) {
        height: 40vh;
      }

      @include breakpoint($xxxxlarge) {
        height: 35vh;
      }
    }

    &.scenario {
      @include breakpoint($xlarge) {
        height: auto;
        width: 70%;
      }

      @include breakpoint($xxxlarge) {
        width: 65%;
      }

      @include breakpoint($xxxxlarge) {
        width: 50%;
      }
    }
  }
}
</style>
